export { default } from './PersonalInfo';
